export const CARRIER_TELSTRA = 'TELSTRA';
export const CARRIER_OPTUS = 'OPTUS';
export const CARRIER_NBN = 'NBN';
export const CARRIER_AAPT = 'AAPT';
export const CARRIER_VOCUS = 'VOCUS';
export const CARRIER_DGTEK = 'DGTEK';

export const SERVICE_NBN = 'nbn'
export const SERVICE_FIBRE = 'fibre'
export const SERVICE_FLIP_TO_FIBRE = 'flipToFibre'

export const CARRIERS = [
    CARRIER_TELSTRA,
    CARRIER_OPTUS,
    CARRIER_NBN,
    CARRIER_AAPT,
    CARRIER_VOCUS,
    CARRIER_DGTEK
];
export const mapCarriersToData = {
    [CARRIER_TELSTRA]: 'telstra',
    [CARRIER_OPTUS]: 'optus',
    [CARRIER_NBN]: 'nbnEnterprise',
    [CARRIER_AAPT]: 'aapt',
    [CARRIER_VOCUS]: 'vocus',
    [CARRIER_DGTEK]: 'dgtek'
};

export const ConvertTitle = (planSpeed) => {
    switch (planSpeed) {
        case "nbn50":
            return {
                title: "Home Business nbn™",
                desc: "Home-based businesses",
            };
        case "nbn100":
            return {
                title: "Start-up nbn™",
                desc: "Growing businesses seeking great value",
            };
        case "nbn250":
            return {
                title: "Accelerator nbn™",
                desc: "Small businesses reliant on the cloud",
            };
        case "nbn500":
            return {
                title: "Performance nbn™",
                desc: "Robust offices with heavy usage",
            };
        case "nbn1000":
            return {
                title: "Power Move™",
                desc: "Businesses moving to the next stage",
            };
        default:
            break;
    }
};

export const NO_CONTRACT = 'no-contract';
export const FIXED_CONTRACT = '12-contract';
export const FIXED_CONTRACT_18 = '18-contract';
export const NO_LOCK_IN = 'No lock-in';
export const NO_LOCK_IN_CONTRACT = 'No lock-in contract';
export const SECRET_PASS = 'Y3T2wcAX2SpBaAZDJYaMHCGn2Yd3RHtz'
export const CONTRACT_18 = '18-month contract'
export const RECOMMENDED = 'Recommended'
export const BRAND_EXETEL = 'exetel'
export const OFFER_ENDING_TEXT = false; //'Offers end 2 July, 2024.'
export const UNCONNECTED_SERVICES_CAMPAIGNS = 'UNCONNECTED-H2-FY25'


// WEBPACK FOOTER //
// ./resources/assets/js/constants.js